<template>
    <div>
        <v-dialog persistent max-width="900" v-model="showCreditDebitModal" @close="close()">
            <v-card>
                <!--<v-card-title class="headline">Use Google's location service?</v-card-title>-->
                <v-card-title class="blue-grey darken-2 white--text">
                    <span class="headline">Nota Crédito/Débito</span>
                </v-card-title>

                <v-card-text class="text-xs-center">
                    <v-container>

                        <v-radio-group v-model="docTypeId" row>
                            <v-radio label="Nota de Crédito" :value="Types.document_type.NOTA_CREDITO"></v-radio>
                            <v-radio label="Nota de Débito" :value="Types.document_type.NOTA_DEVOLUCAO"></v-radio>
                        </v-radio-group>

                        <v-data-table xs12
                                      :headers="headers"
                                      :items="formSellLines"
                                      class="elevation-1"
                                      no-data-text=" "
                                      no-results-text="nenhum resultado"
                                      rows-per-page-text="por página"
                                      disable-initial-sort
                                      hide-actions
                        >
                            <v-progress-linear small v-slot:progress color="indigo" indeterminate></v-progress-linear>
                            <template slot="items" slot-scope="props">
                                <td class="text-xs-left" style="width: 80px">{{ props.item.article.code}}</td>
                                <td class="text-xs-left">{{ props.item.article.name}}</td>
                                <td class="text-xs-right" style="width: 150px">{{props.item.sell_price | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}</td>
                                <td class="text-xs-right" style="width: 80px">{{props.item.sold_quantity}} <span style="color: grey">(1)</span></td>
                                <td class="text-xs-right" style="width: 80px">{{props.item.discount}}</td>
                                <td class="text-xs-right" style="width: 130px">
                                    {{props.item.subtotal | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}
                                    <span style="color: grey">(7.500,00)</span>
                                </td>
                                <!--Actions-->
                                <td class="justify-center layout px-0">
                                    <v-icon class="mt-2 mr-2" @click="openSellLineDialog(props.item, props.index)">edit</v-icon>
                                    <v-icon class="mt-2 mr-2" @click="virtuallyDeleteSellLine(props.item)">clear</v-icon>
                                </td>
                                <!--<td style="width: 40px">-->
                                    <!--<v-checkbox-->
                                            <!--:value="props.item.introduced_value > 0 && props.item.enablePayment"-->
                                            <!--:key="props.index"-->
                                            <!--:label="'pagar'"-->
                                            <!--primary-->
                                            <!--:disabled="!props.item.code"-->
                                            <!--hide-details-->
                                            <!--@change="muda(props.item, props.index)"-->
                                    <!--&gt;</v-checkbox>-->
                                <!--</td>-->
                            </template>

                        </v-data-table>
                        <v-layout wrap style="margin-left: -8px">
                            <v-btn style="margin-bottom: -30px; margin-top: 10px" color="blue-grey" class="white--text" @click="openSellLineDialog(null, -1)">
                                <v-icon left dark>add</v-icon>Novo
                            </v-btn>
                        </v-layout>
                    </v-container>


                </v-card-text>

                <!---->
                <v-divider></v-divider>
                <v-container fluid pa-1>
                    <v-layout wrap>
                        <!--<v-flex shrink py-1>-->
                            <!--<v-chip label color="grey lighten-4" class="customCss" >Será gerado:<b> Nota de Débito</b></v-chip>-->
                        <!--</v-flex>-->
                        <v-spacer color="grey"></v-spacer>
                        <v-flex shrink py-1>
                            <v-chip label color="grey lighten-2" class="customCss" >Total Fatura: </v-chip>
                        </v-flex>
                        <v-flex shrink py-1>
                            <v-chip label :color=" true ? 'green lighten-4' : 'red lighten-4'" class="customCss" >Diferença: </v-chip>
                        </v-flex>
                        <v-flex shrink py-1>
                            <v-divider
                                    class="mx-2"
                                    inset
                                    vertical
                            ></v-divider>
                        </v-flex>
                        <v-flex shrink py-1>
                            <v-chip label color="grey darken-1 grey--text text--lighten-2">Total: </v-chip>
                        </v-flex>
                    </v-layout>
                </v-container>

                <v-divider></v-divider>
                <br>
                <v-card-actions>
                    <v-btn v-if="!loading" color="grey darken-1" flat @click="close()">Cancelar</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn v-if="!loading" color="primary" @click="save()">Guardar</v-btn>
                    <v-progress-circular v-else indeterminate color="primary" m-2 ></v-progress-circular>
                </v-card-actions>

            </v-card>
        </v-dialog>

    </div>
</template>

<script>
    import Vue from 'vue';
    import {Types} from "../../config";
    import {eventBus} from "../../main";

    export default {
        name: "CreditDebitNote",

        created () {
            let vm = this;
            this.onModalOpen(vm);
        },
        beforeDestroy(){
            eventBus.$off('onCreditDebitModalOpen');
            this.close();
        },


        data(){
            return {
                Types,
                loading: false,
                docTypeId: '',
                formSellLines: [],
                creditDebitNote: null,
                sellLineIndex: '',
                articles: [],

                headers: [
                    { text: 'Código', align: 'left', value: 'article.code' },
                    { text: 'Descrição', align: 'left', value: 'installment'},
                    { text: 'Preço', align: 'right', value: 'sell_price' },
                    { text: 'Quant.', align: 'right', value: 'sold_quantity' },
                    { text: 'Desconto', align: 'right', value: 'discount' },
                    { text: 'Subtotal', align: 'right', value: 'subtotal', sortable: false },
                    { text: 'Ações', align: 'right', value: 'subtotal', sortable: false },
                ],
            }
        },

        components:{
            
        },

        computed:{
            showCreditDebitModal: {
                get(){
                    return this.$store.getters.getShowCreditDebitModal;
                },
                set(value){
                    this.$store.dispatch('setShowCreditDebitModal', value);
                }
            },
            selectedInvoice: {
                get(){
                    return this.$store.getters.getSelectedInvoice;
                },
                set(value){
                    this.$store.dispatch('setSelectedInvoice', value);
                }
            },
            showNewSellLineModal:{
                get(){
                    return this.$store.getters.getShowNewSellLineModal;
                },
                set(value){
                    this.$store.dispatch('setShowNewSellLineModal', value);
                }
            },
        },

        methods: {
            onModalOpen(vm){
                eventBus.$on('onCreditDebitModalOpen', function (sellLines, articles) {
                    vm.copySellLines(sellLines, vm);
                    vm.articles = articles;
                });
            },

            openSellLineDialog(item, index){
                // this.consoleLog('sellLine index: '+index);
                this.sellLineIndex = index;
                this.sellLine = item ? item : this.getNewEmptySellLine();

                this.showNewSellLineModal = true;
                eventBus.$emit('onSellLineModalOpen', this.sellLine, this.articles, index);
            },

            getNewEmptySellLine(){
                return {
                    sells_id: '',
                    articles_id: '',
                    detail: '',
                    sell_price: '',
                    discount: '',
                    sold_quantity: 1,
                    quantity_to_be_delivery: 0,
                    subtotal: 0,
                    article_name: ''
                };
            },

            copySellLines(sellLines, vm){
                vm.formSellLines = []; //cleaning array
                for(let i=0; i<sellLines.length; i++){
                    let sl = sellLines[i];
                    let newSellLine = {
                        articles_id: sl.articles_id,
                        detail: sl.detail,
                        discount: sl.discount,
                        id: sl.id,
                        quantity_to_be_delivered: sl.quantity_to_be_delivered,
                        sell_price: sl.sell_price,
                        sells_id: sl.sells_id,
                        sold_quantity: sl.sold_quantity,
                        subtotal: sl.subtotal,
                        article: {
                            code: sl.article.code,
                            description: sl.article.description,
                            active_state: sl.article.active_state,
                            category_id: sl.article.category_id,
                            subcategory_id: sl.article.subcategory_id,
                            companies_id: sl.article.companies_id,
                            id: sl.article.id,
                            stock: sl.article.stock,
                            min_stock: sl.article.min_stock,
                            name: sl.article.name,
                            price: sl.article.price,
                            series: sl.article.series,
                            types_id: sl.article.types_id,
                            types_unit_type: sl.article.types_unit_type,
                        }
                    };

                    vm.formSellLines.push(newSellLine);
                }
            },

            save(){
                this.consoleLog('saving');
                this.loading = true;
                try{
                    Vue.axios.post('invoice', {
                        doc_type: this.docTypeId,
                        sellLines: JSON.stringify(this.formSellLines),
                        invoice: this.selectedInvoice,
                    }).then(response=>{
                        this.consoleLog(response);
                        if(!response.data.success){
                            eventBus.$emit('onCreditDebitNoteSaved', false);
                            return;
                        }
                        this.creditDebitNote = response.data.response.creditDebitNote;
                        eventBus.$emit('onCreditDebitNoteSaved', true, '');
                    }).catch(error=>{

                    }).finally(()=>{
                        this.loading = false;
                    })
                }catch (e) {
                    this.consoleLog(e);
                }
            },

            close(){
                this.showCreditDebitModal = false;
            }
        },

    }
</script>

<style scoped>
    .customCss {
        text-align: right;
        font-size: 12px;
        color: #7d7c7d;
    }
</style>